import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Presentation } from "lucide-react";
import api from "../lib/api";
import { sanitizePage } from "../lib/sanitizeContent";
import BlocksRenderer from "../components/blocks/Blocks";
import SlideDeck from "../components/SlideDeck";
import { PageLoader, SyncPending } from "../components/Loaders";

const PageView = () => {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [status, setStatus] = useState("loading");
  const [deck, setDeck] = useState(false);

  useEffect(() => {
    setStatus("loading");
    api
      .get(`/pages/${slug}`)
      .then(({ data }) => {
        setPage(sanitizePage(data));
        setDeck(data.mode === "slide");
        setStatus("ok");
      })
      .catch((e) => setStatus(e?.response?.status === 404 ? "pending" : "error"));
  }, [slug]);

  if (status === "loading") return <PageLoader />;
  if (status !== "ok" || !page) return <SyncPending />;

  const isSlide = page.mode === "slide";
  const inDeck = isSlide && deck;

  return (
    <div>
      {!inDeck && (
        <section className="pillet-hatch border-b border-pillet-forest">
          <div className="max-w-4xl mx-auto px-5 py-14 flex items-end justify-between gap-6 pillet-reveal">
            <div>
              <p className="font-heading uppercase tracking-[0.3em] text-pillet-sage text-xs mb-4">
                Livrable
              </p>
              <h1 className="font-heading font-extrabold text-3xl sm:text-4xl lg:text-5xl text-white leading-tight">
                {page.title}
              </h1>
            </div>
            {isSlide && (
              <button
                onClick={() => setDeck(true)}
                data-testid="mode-toggle"
                className="hidden sm:flex items-center gap-2 pillet-dashed px-4 py-2.5 font-heading uppercase text-xs tracking-widest text-pillet-sage hover:bg-pillet-sage hover:text-black transition-colors shrink-0"
              >
                <Presentation size={15} />
                Mode présentation
              </button>
            )}
          </div>
        </section>
      )}

      {inDeck ? (
        <SlideDeck blocks={page.blocks} onExit={() => setDeck(false)} />
      ) : (
        <section className="max-w-3xl mx-auto px-5 py-10">
          {isSlide && (
            <button
              onClick={() => setDeck(true)}
              className="sm:hidden mb-6 flex items-center gap-2 pillet-dashed px-4 py-2.5 font-heading uppercase text-xs tracking-widest text-pillet-sage"
            >
              <Presentation size={15} /> Mode présentation
            </button>
          )}
          <BlocksRenderer nodes={page.blocks} />
        </section>
      )}
    </div>
  );
};

export default PageView;
